var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFriendsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Friends / Active") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "#484888",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-387.000000, -1301.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends-/-Active",
    transform: "translate(387.000000, 1301.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "User-Group",
    mask: "url(#mask-2)",
    stroke: "#484888",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,7.5 C13.5707,7.5 15.25,5.82065 15.25,3.75 C15.25,1.67852 13.5707,0 11.5,0 C9.4294,0 7.74997547,1.67852 7.74997547,3.75 C7.7426,5.8132 9.4103,7.4926 11.4735,7.5 L11.5,7.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,16.5 C7.9945,16.5 5,16.0256 5,14.1265 C5,12.2273 7.9752,10.5 11.5,10.5 C15.0055,10.5 18,12.2109 18,14.1092 C18,16.0075 15.0248,16.5 11.5,16.5 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4324,7.0006 L5.40946,7.0006 C3.62099,6.9942 2.1753,5.53846 2.1817285,3.74999 C2.1817285,1.95434 3.63748,0.49933 5.4324,0.49933 M2.93243,15.8744 C1.21009,15.6552 0,15.1273 0,14.0236 C0,12.9184 1.20561,11.8828 2.93243,11.3557",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsActive);
export default __webpack_public_path__ + "static/media/friends-active.1ead265433245b4d63fb1001ac71a532.svg";
export { ForwardRef as ReactComponent };